import { Text, Card, CardHeader, makeStyles, Divider, mergeClasses } from '@fluentui/react-components';
import { AgentKnowledgeBase } from '../../../../domain/agents/models/Agent';
import useOverviewStyles from '../styles/AgentOverviewStyles';
import { AlwaysOnScrollBarStyles, customColors } from '../../../../styles';

const useStyles = makeStyles({
    cardOverrides: {
        maxHeight: '325px',
        paddingBlock: '20px',
        paddingInline: '25px',
    },
    knowledgeSourcesText: {
        color: customColors.protivitiDarkBlue,
        overflowY: 'auto',
        scrollbarGutter: 'stable',
        ...AlwaysOnScrollBarStyles,
    },
});

interface KnowledgeSourceCardProps {
    knowledgeSources: AgentKnowledgeBase | undefined;
}

const KnowledgeSourceCard: React.FC<KnowledgeSourceCardProps> = ({ knowledgeSources }) => {
    const styles = useStyles();
    const overviewStyles = useOverviewStyles();

    return (
        <Card className={mergeClasses(overviewStyles.card, styles.cardOverrides)}>
            <CardHeader
                className={overviewStyles.cardHeader}
                header={
                    <header className={overviewStyles.header}>
                        <Text className={overviewStyles.headerTitle}>Agent Knowledge Source</Text>
                        <Divider />
                    </header>
                }
            />

            <Text className={styles.knowledgeSourcesText}>{knowledgeSources?.content ?? ''}</Text>
        </Card>
    );
};

export default KnowledgeSourceCard;
